import React, {useCallback} from "react";
import {MY_PRICE, CMP} from "../../modules/PriceBlock/PriceTypes";

const PriceTypeToggle = ({priceType, onChange}) => {
  const isMyPrice = priceType === MY_PRICE;

  const handleMyPriceChange = useCallback(() => {
    onChange({priceType: MY_PRICE});
  }, [priceType]);

  const handleCmpChange = useCallback(() => {
    onChange({priceType: CMP});
  }, [priceType]);

  return (
    <React.Fragment>
      <span className="pdp-prices-block__option">
          <input
            type="radio"
            name="price-radio-set"
            id="pdp-price-radio-1"
            checked={isMyPrice}
            onChange={handleMyPriceChange}
          />
          <label
            htmlFor="pdp-price-radio-1"
            className="pdp-prices-block__label pdp-prices-block__label--radio"
          >
            My Price
          </label>
      </span>
      <span className="pdp-prices-block__option">
          <input
            type="radio"
            name="price-radio-set"
            id="pdp-price-radio-2"
            checked={!isMyPrice}
            onChange={handleCmpChange}
          />
          <label
            htmlFor="pdp-price-radio-2"
            className="pdp-prices-block__label pdp-prices-block__label--radio"
          >
            CMP
          </label>
      </span>
    </React.Fragment>
  );
};

PriceTypeToggle.defaultProps = {
  priceType: MY_PRICE
};

export default PriceTypeToggle;